var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_document",
            title: "Beauftragungsdokumente",
          },
        },
        [
          _c("csp-desktop-firm-configurable-documents-form", {
            attrs: {
              "context-id": _vm.contextId,
              "context-type": _vm.contextType,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }